import React from 'react';
import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps } from '@mui/material';
import { IconName } from '../../constants/icons';
import { ICON_COLORS, ICON_SIZES } from '../../utils/iconReplacements';
import { GoogleMaterialIcon } from './GoogleMaterialIcon';

interface GoogleIconButtonProps extends Omit<MuiIconButtonProps, 'children'> {
  iconName: IconName;
  iconSize?: keyof typeof ICON_SIZES | number;
  iconColor?: keyof typeof ICON_COLORS | string;
  fill?: 0 | 1;
  weight?: 100 | 200 | 300 | 400 | 500 | 600 | 700;
}

export const GoogleIconButton: React.FC<GoogleIconButtonProps> = ({
  iconName,
  iconSize = 'medium',
  iconColor = 'primary',
  fill = 0,
  weight = 400,
  disabled = false,
  ...iconButtonProps
}) => {
  const getIconSize = (size: keyof typeof ICON_SIZES | number): number => {
    return typeof size === 'number' ? size : ICON_SIZES[size];
  };

  const getIconColor = (color: keyof typeof ICON_COLORS | string): string => {
    if (disabled) return ICON_COLORS.disabled;
    return typeof color === 'string' && color.startsWith('#') ? color : ICON_COLORS[color as keyof typeof ICON_COLORS] || color;
  };

  return (
    <MuiIconButton disabled={disabled} {...iconButtonProps}>
      <GoogleMaterialIcon
        name={iconName}
        size={getIconSize(iconSize)}
        color={getIconColor(iconColor)}
        fill={fill}
        weight={weight}
      />
    </MuiIconButton>
  );
};